<template>
  <el-select
    class="icon-selector"
    v-model="val"
    filterable
    clearable
    reserve-keyword
    placeholder="Icon"
    v-bind="$attrs"
  >
    <i slot="prefix" :class="[val, 'prefix']" v-if="val"></i>
    <el-option
      v-for="icon in icons"
      :key="icon.value"
      :label="icon.label"
      :value="icon.value"
    >
      <span
        ><i
          :class="icon.value"
          style="font-weight: bold; margin-right: 10px"
        />{{ icon.label }}</span
      >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "icon-select-element",
  props: {
    value: String,
    icons: {
      type: Array,
      required: true
    }
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style lang="stylus">
.icon-selector
    & .el-input__inner
        text-overflow ellipsis
</style>

<style scoped lang="stylus">
.prefix
    font-size 2em
    height 100%
    line-height 1.2em
    color #606266
</style>
